// extracted by mini-css-extract-plugin
export default {"featuredItem":"feature-section_featuredItem__2n0j1","textContainer":"feature-section_textContainer__jIEq6","imageContainer":"feature-section_imageContainer__Bk5QQ"};